export default __webpack_public_path__ + "static/media/discipline-humanities.33bb4c8d.svg";